import { GracePeriodValues } from 'src/utils/constants/distributors';
import {
  calculateEndDateFromGracePeriod,
  getFirstRentDate,
  setGracePeriod
} from 'src/utils/contracts';
import momentLocalTimezone from 'src/utils/momentLocalTimezone';

const getFirstRentDateForFirstUpfrontRentModality = (values, parameter) => {
  if (values.firstRentDate) {
    return momentLocalTimezone(values.firstRentDate).subtract(1, 'months');
  }
  return values.isFirstUpfrontRentModality
    ? momentLocalTimezone()
    : getFirstRentDate(
        momentLocalTimezone(),
        values.initialPayment,
        values.isFirstUpfrontRentModality,
        setGracePeriod(values, parameter)
      );
};

export default (values, parameter) => {
  if (values.enableMsi) {
    const firstRentDate =
      Number(values.initialPayment) === 0
        ? momentLocalTimezone()
        : momentLocalTimezone().add(1, 'months');
    return {
      ...values,
      startDate: momentLocalTimezone(),
      firstRentDate,
      gracePeriod:
        Number(values.initialPayment) === 0
          ? GracePeriodValues.SAME_DAY_AS_CONTRACT_STARTS
          : GracePeriodValues.ZERO,
      endDate:
        Number(values.initialPayment) === 0
          ? momentLocalTimezone().add(values.term - 1, 'months')
          : momentLocalTimezone()
              .add(1, 'months')
              .add(values.term - 1, 'months'),
      payday: Math.min(momentLocalTimezone().date(), 25),
      isFirstUpfrontRentModality: false
    };
  }

  return {
    ...values,
    startDate: values.startDate || momentLocalTimezone(),
    firstRentDate: getFirstRentDateForFirstUpfrontRentModality(
      values,
      parameter
    ),
    secondRentDate:
      values.secondRentDate || momentLocalTimezone().add(2, 'months'),
    gracePeriod: values.gracePeriod || setGracePeriod(values, parameter),
    endDate:
      values.endDate ||
      calculateEndDateFromGracePeriod(
        momentLocalTimezone(),
        values.term,
        setGracePeriod(values, parameter),
        values.isFirstUpfrontRentModality
      ),
    payday: values.payday || Math.min(momentLocalTimezone().date(), 25),
    isFirstUpfrontRentModality: values.isFirstUpfrontRentModality
  };
};
